import { useQuery } from '@tanstack/react-query';
import { EventService } from '../services';
import { queryKeys } from './query-keys';
function useEventIndividualRankingQuery(eventId, params) {
  return useQuery({
    queryKey: queryKeys.eventIndividualRanking.detail(eventId, params),
    queryFn: () => EventService.getIndividualRanking(eventId, params),
    enabled: eventId !== undefined,
    staleTime: Infinity
  });
}
export default useEventIndividualRankingQuery;